import * as React from "react";
const SvgSearchBold = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#2D2D2D"
      d="M14.913 15.697a.555.555 0 1 0 .784-.784l-.392.392zm-7.803-2.03v-.556a6 6 0 0 1-6-6H0a7.11 7.11 0 0 0 7.11 7.11zm6.556-6.556h-.555a6 6 0 0 1-6 6v1.11a7.11 7.11 0 0 0 7.11-7.11zM7.11.555v.555a6 6 0 0 1 6.001 6h1.11A7.11 7.11 0 0 0 7.111 0zm0 0V0A7.11 7.11 0 0 0 0 7.11h1.11a6 6 0 0 1 6-6zm8.195 14.75.392-.393-3.277-3.277-.393.392-.392.393 3.278 3.277z"
    />
  </svg>
);
export default SvgSearchBold;
